import moment from 'moment';

export const formatNotificationTime = (date: Date, now: Date = new Date()): string => {
  const value = moment(date);
  const today = moment(now);
  const time = value.format('h:mm A');

  if (value.isSame(today, 'day')) {
    return `Today at ${time}`;
  }
  if (value.isSame(today.clone().subtract(1, 'day'), 'day')) {
    return `Yesterday at ${time}`;
  }
  if (value.isSameOrAfter(today.clone().startOf('week'))) {
    return `This ${value.format('dddd')} at ${time}`;
  }
  if (value.isSameOrAfter(today.clone().subtract(1, 'week').startOf('week'))) {
    return `Last ${value.format('dddd')} at ${time}`;
  }
  return value.format('dddd, MMMM DD, YYYY');
};
